const MEETING_MUTE_STATUS_ENABLE = 1;
const MEETING_MUTE_STATUS_DISABLE = 0;

const MEETING_RECORD_STATUS_ENABLE = 1;
const MEETING_RECORD_STATUS_DISABLE = 0;

const MEETING_LOCK_STATUS_ENABLE = 1;
const MEETING_LOCK_STATUS_DISABLE = 0;

const PARTY_MUTE_STATUS_ENABLE = 1;
const PARTY_MUTE_STATUS_DISABLE = 0;

const PARTY_MORE_MUTE_STATUS_ENABLE = 1;
const PARTY_MORE_MUTE_STATUS_DISABLE = 0;

const PARTY_MUTE_OVERRIDE_STATUS_ENABLE = 1;
const PARTY_MUTE_OVERRIDE_STATUS_DISABLE = 0;

const PARTY_WAIT_LINE_STATUS_ENABLE = 1;
const PARTY_WAIT_LINE_STATUS_DISABLE = 0;

export function getPartyWaitLineStatusEnable() {
  return PARTY_WAIT_LINE_STATUS_ENABLE;
}

export function getPartyWaitLineStatusDisable() {
  return PARTY_WAIT_LINE_STATUS_DISABLE;
}

export function getPartyMuteOverrideStatusEnable() {
  return PARTY_MUTE_OVERRIDE_STATUS_ENABLE;
}

export function getPartyMuteOverrideStatusDisable() {
  return PARTY_MUTE_OVERRIDE_STATUS_DISABLE;
}

export function getMeetingMuteStatusEnable() {
  return MEETING_MUTE_STATUS_ENABLE;
}

export function getMeetingMuteStatusDisable() {
  return MEETING_MUTE_STATUS_DISABLE;
}

export function getMeetingRecordStatusEnable() {
  return MEETING_RECORD_STATUS_ENABLE;
}

export function getMeetingStopRecordStatusDisable() {
  return MEETING_RECORD_STATUS_DISABLE;
}

export function getMeetingLockStatusEnable() {
  return MEETING_LOCK_STATUS_ENABLE;
}

export function getMeetingLockStatusDisable() {
  return MEETING_LOCK_STATUS_DISABLE;
}

export function getPartyMuteStatusEnable() {
  return PARTY_MUTE_STATUS_ENABLE;
}

export function getPartyMuteStatusDisable() {
  return PARTY_MUTE_STATUS_DISABLE;
}

export function getPartyMoreMuteStatusEnable() {
  return PARTY_MORE_MUTE_STATUS_ENABLE;
}

export function getPartyMoreMuteStatusDisable() {
  return PARTY_MORE_MUTE_STATUS_DISABLE;
}
